import "./TemplatesMenu.scss";

export default function ResourcesMenu() {
  return (
    <div className={"templates-menu pricing-menu"}>
      <ul className="pricing-links">
        <li>
          <a href="/feature/case-studies.html">
            Case Studies
          </a>
        </li>
        <li>
          <a href="/feature/blog">
            Blog
          </a>
        </li>
      </ul>
    </div>
  );
}
